export const mobile = 600;
export const laptop = 1200;

export default {
    'Mobile': `@media screen and (max-width: ${mobile}px)`,
    'MobileHorizontal': `@media screen and (max-width: ${mobile}px) and (orientation: landscape)`,
    'AfterMobile': `@media screen and (min-width: ${mobile + 1}px)`,
    'Laptop': `@media screen and (min-width: ${mobile + 1}px) and (max-width: ${laptop}px)`,
    'Desktop': `@media screen and (min-width: ${laptop + 1}px)`
};


// WEBPACK FOOTER //
// ./src/Constants/responsive.ts